import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      window.location.href = `/#${targetId}`;
      return;
    }
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-content">
          {/* Logo Section */}
          <div className="footer-logo-section">
            <Link to="/" className="footer-logo">
              <img src="/img/monkStack-Logo-BlackText.png" alt="monkStack logo" className="footer-logo-image" />
              <div className="footer-logo-fallback">
                <span className="monk">monk</span>
                <span className="stack">stack</span>
              </div>
            </Link>
            <p className="footer-tagline">AI and Engineering Solutions</p>
            
            {/* Social Media Section */}
            <div className="footer-social-section">
              <h3 className="footer-section-title">Follow Us</h3>
              <div className="footer-social-links">
                <a 
                  href="https://in.linkedin.com/company/monkstack" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label="Follow us on LinkedIn"
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="footer-nav-section">
            <h3 className="footer-section-title">Quick Links</h3>
            <ul className="footer-nav-links">
              {/* <li><a href="#approach" onClick={(e) => handleNavClick(e, 'approach')}>Our Approach</a></li>
              <li><a href="#collaborator" onClick={(e) => handleNavClick(e, 'collaborator')}>Our Collaborator</a></li>
              <li><a href="#industries" onClick={(e) => handleNavClick(e, 'industries')}>Industries</a></li>
              <li><a href="#services" onClick={(e) => handleNavClick(e, 'services')}>Services</a></li>
              <li><Link to="/meet-the-team">Meet the Team</Link></li>
              <li><Link to="/case-studies">Case Studies</Link></li> */}


            <li><a href="#home" onClick={(e) => handleNavClick(e, 'home')}>Home</a></li>
            <li><a href="#services" onClick={(e) => handleNavClick(e, 'services')}>Services</a></li>
            <li><a href="#approach" onClick={(e) => handleNavClick(e, 'approach')}>Our approach</a></li>
            <li><Link to="/case-studies">Case Studies</Link></li>
            {/* <li><a href="#testimonials" onClick={(e) => handleNavClick(e, 'testimonials')}>Testimonials</a></li> */}
            <li><Link to="/about-monkstack">About Us</Link></li>
            {/* <li><a href="#collaborator" onClick={(e) => handleNavClick(e, 'collaborator')}>Our collaborator</a></li>
            <li><a href="#industries" onClick={(e) => handleNavClick(e, 'industries')}>Industries</a></li>
          
            <li><Link to="/case-studies">Case Studies</Link></li> */}
            <li><Link to="/careers">Careers</Link></li>
            {/* <li><a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>Contact us</a></li> */}

            </ul>
          </div>

          {/* Contact Information */}
          <div className="footer-contact-section">
            <h3 className="footer-section-title">Contact Us</h3>
            <div className="footer-contact-info">
               <div className="footer-contact-item">
                <span className="footer-contact-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                  </svg>
                </span>
                <a href="mailto:info@monkstack.com" className="footer-contact-link">info@monkstack.com</a>
              </div>
             <div className="footer-contact-item">
                <span className="footer-contact-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="currentColor"/>
                  </svg>
                </span>
                <a href="tel:+918600358700" className="footer-contact-link">+91 - 8600 35 8700</a>
              </div>
              <div className="footer-contact-item">
                <span className="footer-contact-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="currentColor"/>
                  </svg>
                </span>
                <a
                  href="https://www.google.com/maps/place/Monkstack+Solutions+LLP/@18.4555333,73.917852,17z/data=!4m14!1m7!3m6!1s0x3bc2eb7c34619abf:0x9d1608de772491db!2sMonkstack+Solutions+LLP!8m2!3d18.4555282!4d73.9204269!16s%2Fg%2F11mlxpg1_l!3m5!1s0x3bc2eb7c34619abf:0x9d1608de772491db!8m2!3d18.4555282!4d73.9204269!16s%2Fg%2F11mlxpg1_l?entry=ttu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-contact-link"
                >OFFICE NO 311 - NYATI ETERNITY, UNDRI, PUNE, 411060</a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} monkstack. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

